import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import RoleProtectedRoute from './components/RoleProtectedRoute.jsx';
import Layout from './components/Layout.jsx';
import { useAppAuth } from './components/AuthContext.jsx';
import Home from './pages/Home.jsx';
import Login from './pages/Login.jsx';
import ForgotPassword from './pages/ForgotPassword.jsx';
import ResetPassword from './pages/ResetPassword.jsx';
import AcceptInvite from './pages/AcceptInvite.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Activities from './pages/Activities.jsx';
import Goals from './pages/Goals.jsx';
import Journey from './pages/Journey.jsx';
import Accounts from './pages/Accounts.jsx';
import LevelAssignment from './pages/LevelAssignment.jsx';
import Cisla from './pages/Cisla.jsx';
import KPI from './pages/KPI.jsx';
import Kontakty from './pages/Kontakty.jsx';
import Report from './pages/Report.jsx';
import Milniky from './pages/Milniky.jsx';
import Database from './pages/Database.jsx';
import JRMaklerDetail from './pages/JRMaklerDetail.jsx';
import JrOverview from './pages/JrOverview.jsx';
import CommissionImport from './pages/CommissionImport.jsx';
import JrCalendar from './pages/JrCalendar.jsx';
import Parametry from './pages/Parametry.jsx';
import JrSprava from './pages/JrSprava.jsx';
import JrPripominka from './pages/JrPripominka.jsx';
import SystemMap from './pages/SystemMap.jsx';
import MyAccount from './pages/MyAccount.jsx';
import { PolicyProvider } from './components/PolicyContext.jsx';

function DashboardHome() {
  const { user } = useAppAuth();
  if (user?.role === 'JCH') return <Navigate to="/dashboard/cisla" replace />;
  return user?.role === 'JR' ? <JrOverview /> : <Dashboard />;
}

export default function App() {
  return (
    <PolicyProvider><Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Navigate to="/login" replace />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/accept-invite" element={<AcceptInvite />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute><DashboardHome /></ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/import"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <CommissionImport />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/kalendar"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <JrCalendar />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/parametry"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <Parametry />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/sprava"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <JrSprava />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/pripominka"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <JrPripominka />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/mapa"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <SystemMap />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/my-account"
          element={<ProtectedRoute><MyAccount /></ProtectedRoute>}
        />
        <Route
          path="/dashboard/activities"
          element={<ProtectedRoute><Activities /></ProtectedRoute>}
        />
        <Route
          path="/dashboard/goals"
          element={<ProtectedRoute><Goals /></ProtectedRoute>}
        />
        <Route
          path="/dashboard/journey"
          element={<ProtectedRoute><Journey /></ProtectedRoute>}
        />
        <Route
          path="/accounts"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <Accounts />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/level-assignment"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <LevelAssignment />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/database"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <Database />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/cisla"
          element={
            <RoleProtectedRoute allowedRoles={['JCH']}>
              <Cisla />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/kontakty"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <Kontakty />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/kpi"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <KPI />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/report"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <Report />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/milniky"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <Milniky />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/database/:id"
          element={
            <RoleProtectedRoute allowedRoles={['JR', 'JCH']}>
              <JRMaklerDetail />
            </RoleProtectedRoute>
          }
        />
      </Route>
    </Routes></PolicyProvider>
  );
}
